var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_thank_you)?_c('div',{staticClass:"thank_you_message"},[_c('div',{staticStyle:{"font-size":"20px","margin-bottom":"10px"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]),(_vm.end_with_thank_you)?_c('span',[_vm._v(" Thank you! ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }